export default __webpack_public_path__ + "static/media/AppraisalPP3.bbc3c765.jpg";